"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BPMCaseStep = void 0;
/*
Includes all the steps in the BPM case for Charge Station, Charge Card and Reimbursement
*/
var BPMCaseStep;
(function (BPMCaseStep) {
    BPMCaseStep["WaitForCallback"] = "Terugbelverzoek";
    BPMCaseStep["CallbackFailed"] = "Terugbellenmislukt";
    BPMCaseStep["WaitForDataCollection"] = "Informatieopvragenbijdeklant";
    BPMCaseStep["DataCollectionFailed"] = "Geeninformatievanklantontvangen";
    BPMCaseStep["WaitForQuotation"] = "Offertedelenmetklant";
    BPMCaseStep["WaitForAdditionalInformationFromCustomer"] = "Wachtopaanvullendeinformatieklant";
    BPMCaseStep["WaitForCustomer"] = "Wachtopklant";
    BPMCaseStep["WaitForServicePartner"] = "WachtopaanvullendeinformatieSP";
    BPMCaseStep["WaitForQuotationApproval"] = "Offerteterakkoordbijklant";
    BPMCaseStep["QuotationRejected"] = "Offertegeweigerd";
    BPMCaseStep["WaitForCooldown"] = "Bestellingbinnenbedenktermijn";
    BPMCaseStep["WaitForInstallation"] = "Wachtopinstallatie";
    BPMCaseStep["WaitForInvoice"] = "Wachtopfactuur";
    BPMCaseStep["ProcessReimbursement"] = "Verwerkenzakelijkverrekenen";
    BPMCaseStep["WaitForFulfilment"] = "Afrondenklantverzoek";
    BPMCaseStep["ProcessFinalized"] = "Koppelenlaadpaszv";
    BPMCaseStep["QuotationVerification"] = "OfferteNakijken";
})(BPMCaseStep || (exports.BPMCaseStep = BPMCaseStep = {}));
